<template>
  <div class="safe-box">
    <Header isSafeBox />
    <VideoAnimate />
    <!-- <Footer /> -->
  </div>
</template>

<script>
import VideoAnimate from '../components/animate/VideoAnimate.vue';
import Footer from '../components/common/Footer.vue';
import Header from '../components/common/Header.vue';
import { setMode } from '../utils';

export default {
  components: { Header, Footer, VideoAnimate },
  created() {
    this.$store.commit('setDark', false);
    setMode(false);
  },
  methods: {},
};
</script>
